/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
export const searchSubstring = (substring: string, string: string) =>
  string.toLocaleLowerCase().indexOf(substring.toLocaleLowerCase()) !== -1;
